module.exports = __webpack_public_path__ + "static/media/logo.662613c0.png";